import React from "react";

/**
 * Filtra una lista de citas por rango relativo a HOY.
 * Devuelve {filtered, dateFilter, setDateFilter, Pills}.
 *
 * Opciones soportadas:
 *  - "today"   → solo hoy
 *  - "back3"   → últimos 3 días (incluye hoy)
 *  - "back5"   → últimos 5 días (incluye hoy)
 *  - "next3"   → próximos 3 días (incluye hoy)
 *  - "next5"   → próximos 5 días (incluye hoy)
 *  - "all"     → todas
 */
export const DATE_FILTERS = [
  { k: "today", label: "Hoy" },
  { k: "back3", label: "-3 días" },
  { k: "back5", label: "-5 días" },
  { k: "next3", label: "+3 días" },
  { k: "next5", label: "+5 días" },
  { k: "all", label: "Todas" },
];

function todayISO() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

function shiftISO(days) {
  const d = new Date();
  d.setDate(d.getDate() + days);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

export function filterAppointmentsByDate(appts, key) {
  const today = todayISO();
  if (key === "all") return appts;
  if (key === "today") return appts.filter((a) => a.date === today);
  if (key === "back3") {
    const from = shiftISO(-3);
    return appts.filter((a) => a.date >= from && a.date <= today);
  }
  if (key === "back5") {
    const from = shiftISO(-5);
    return appts.filter((a) => a.date >= from && a.date <= today);
  }
  if (key === "next3") {
    const to = shiftISO(3);
    return appts.filter((a) => a.date >= today && a.date <= to);
  }
  if (key === "next5") {
    const to = shiftISO(5);
    return appts.filter((a) => a.date >= today && a.date <= to);
  }
  return appts;
}

export default function DateRangeFilter({ value, onChange, testidPrefix = "date-filter" }) {
  return (
    <div className="inline-flex flex-wrap items-center gap-1.5 p-1 rounded-full bg-slate-100 border border-slate-200" data-testid={`${testidPrefix}-pills`}>
      {DATE_FILTERS.map((f) => (
        <button
          key={f.k}
          type="button"
          onClick={() => onChange(f.k)}
          data-testid={`${testidPrefix}-${f.k}`}
          className={`px-3 py-1.5 text-xs rounded-full transition font-medium ${
            value === f.k
              ? "bg-[#1E3A8A] text-white shadow-sm"
              : "text-slate-600 hover:bg-white"
          }`}
        >
          {f.label}
        </button>
      ))}
    </div>
  );
}
